module.exports = __webpack_public_path__ + "static/media/135U1_Bathroom.43e8a66a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U1_Bathroom.jpg
// module id = 534
// module chunks = 0